import qs from 'qs';
import { useQuery } from 'react-query';
import { network } from 'services/network';

const getKeyActivitiesTags = (params) => {
    const querystring = qs.stringify({ contractId: params.contractId }, { addQueryPrefix: true, skipNulls: true });
    return network
        .get(`api/bo/getKeyActivitiesTags${querystring}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};
export const useQueryGetKeyActivitiesTags = (params) => {
    return useQuery<{ id: number; contractId: number; tagId: number }[], QueryError>(
        ['getKeyActivitiesTags', params],
        () => getKeyActivitiesTags(params),
        {
            enabled: Boolean(params.contractId),
        },
    );
};
